import { render, staticRenderFns } from "./BaseTLFilter.vue?vue&type=template&id=284b9fc0&"
import script from "./BaseTLFilter.vue?vue&type=script&lang=ts&"
export * from "./BaseTLFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports